import React, { useMemo, useState, useCallback, useEffect, useRef } from 'react'
import { Provider, useDispatch, useSelector } from "react-redux";
import { Request, sendFileRequest } from "./../../SYSTEM/Request"

import CONFIG from './../../SYSTEM/Config.js'

import ChatMessage from "./ChatMessage"


const Chat = () => {
    const USER = useSelector(state => state.USER)
    const [messages, setMessages] = useState([])
    const [text, setText] = useState('')
    const scrollRef = useRef(null)

    const getMessages = async () => {
        try {
            let SEND_DATA = {};

            let data = await Request(SEND_DATA, 'chat/read');
            return data
        } catch (error) {
        }

        return []
    }

    const sendMessage = async (text) => {
        try {
            let SEND_DATA = {
                message: text
            };

            let data = await Request(SEND_DATA, 'chat/leave-message');
            return data
        } catch (error) {
        }

        return false
    }

    const sendFile = async (file) => {
        try {
            let SEND_DATA = {
                file: file
            };

            let data = await sendFileRequest(SEND_DATA, 'chat/send-file');
            return data
        } catch (error) {
        }

        return false
    }

    const sendImage = async (image) => {
        try {
            let SEND_DATA = {
                image: image
            };

            let data = await sendFileRequest(SEND_DATA, 'chat/send-image');
            return data
        } catch (error) {
        }

        return false
    }

    const sendMessageNow = async () => {
        if (!text.length) {
            return
        }

        const result = await sendMessage(text)
        if (result) {
            setText('')
            getMessages()
        }
    }

    const sendImageNow = async (e, file) => {
        const result = await sendImage(file)
        if (result) {
            getMessages()
        }

        if (e.target) {
            e.target.value = null
        }
    }

    const sendFileNow = async (e, file) => {
        const result = await sendFile(file)
        if (result) {
            getMessages()
        }

        if (e.target) {
            e.target.value = null
        }
    }

    const getMessagesNow = async () => {
        const resultMessages = await getMessages()
        if (resultMessages) {
            setMessages(resultMessages)
        }
    }

    const handleKeypress = (e) => {
        if (e.keyCode === 13) {
            sendMessageNow();
        }
    }

    useEffect(() => {
        if (!scrollRef.current) return
        if (!messages.length) return

        ///scrollRef.current.scrolTop

    }, [scrollRef.current, messages])

    useEffect(() => {
        getMessagesNow()

        const timer = setInterval(() => {
            getMessagesNow()
        }, 5000)

        return () => {
            clearInterval(timer)
        }
    }, [])

    return (
        <div className="main_content">
            <div className="chat_holder">
                <div className={ 'chat' }>
                    <div className={ 'messages' } ref={ scrollRef }>
                        { messages.map((message, index) => {
                            return (
                                <ChatMessage
                                    key={ index }
                                    message={ message }
                                />
                            )
                        }) }
                    </div>
                    <div className={ 'bottomRow' }>
                        <div className={ 'files' }>
                            <label
                                className={ 'attachmentButton' }
                            >
                                <img src="/system_images/image.svg" />
                                <input
                                    onChange={ (e) => sendImageNow(e, e.target.files[0]) }
                                    type='file'
                                    accept=".jpg,.png,.jpeg,.gif,.svg"
                                />
                            </label>

                            <label
                                className={ 'attachmentButton' }
                            >
                                <img src="/system_images/file.svg" />
                                <input
                                    onChange={ (e) => sendFileNow(e, e.target.files[0]) }
                                    type='file'
                                    accept=".doc,.docx,.pdf,.xls,.xlsx"
                                />
                            </label>
                        </div>
                        <input
                            className={ 'textInput' }
                            value={ text }
                            onChange={ (e) => setText(e.target.value) }
                            placeholder="Сообщение"
                            onKeyDown={ handleKeypress }
                        />
                        <a
                            className={ 'sendBtn' }
                            onClick={ () => sendMessageNow() }
                        >
                            <img src="/system_images/send.svg" />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Chat
